import React from 'react';
import type { PricingTier } from '../../types/pricing.types';

interface PricingCardProps {
  tier: PricingTier;
}

const PricingCard: React.FC<PricingCardProps> = ({ tier }) => {
  const isBestValue = tier.isBestValue;
  const borderClass = isBestValue ? 'border-2 border-sky-500' : 'border';

  return (
    <div
      className={`${borderClass} rounded-lg p-4 text-center hover:border-sky-500 transition-colors relative`}
    >
      {isBestValue && (
        <span className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-sky-500 text-white px-3 py-1 rounded text-xs">
          BEST VALUE
        </span>
      )}
      <h4 className="font-semibold text-gray-900">{tier.title}</h4>
      {tier.subtitle && <p className="text-xs text-gray-500 mb-2">{tier.subtitle}</p>}
      {!tier.subtitle && <p className="text-xs text-gray-500 mb-2">&nbsp;</p>}
      <p className="text-2xl font-bold text-sky-600">
        {tier.price}
        {tier.priceUnit && <span className="text-lg">{tier.priceUnit}</span>}
      </p>
      {tier.totalPrice && <p className="text-sm text-gray-500">{tier.totalPrice}</p>}
    </div>
  );
};

export default PricingCard;